import React from 'react';
import { Input, Button } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import './UrlInput.css';

const UrlInput = ({ value, onChange, onGenerate, isLoading }) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') onGenerate();
  };

  return (
    <div className="url-input-section">
      <label className="url-label">
        Where should your QR code lead? Paste the link here:
      </label>
      <Input
        className="url-input"
        prefix={<LinkOutlined className="url-icon" />}
        placeholder="https://example.com"
        value={value}
        onChange={(e) => onChange('url', e.target.value)}
        onKeyDown={handleKeyDown}
        size="large"
        allowClear
      />
      {/* <Button
        className="generate-btn"
        type="primary"
        size="large"
        loading={isLoading}
        onClick={onGenerate}
        block
      >
        Make My QR Code
      </Button> */}
    </div>
  );
};

export default UrlInput;
